/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Ico_LabelInputs */

const cs_ares_ico_label = /** @type {(inputs: Ares_Ico_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IČO`)
};

const en_ares_ico_label = /** @type {(inputs: Ares_Ico_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IČO`)
};

/**
* | output |
* | --- |
* | "IČO" |
*
* @param {Ares_Ico_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_ico_label = /** @type {((inputs?: Ares_Ico_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Ico_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_ico_label(inputs)
	return cs_ares_ico_label(inputs)
});